var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsKiosk = function SvgFormsKiosk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.167 13.889V9.722a5.556 5.556 0 00-5.556-5.555H9.722a5.556 5.556 0 00-5.555 5.555v30.556a5.556 5.556 0 005.555 5.555h13.89a5.556 5.556 0 005.555-5.555v-5.556m-25 2.778h25m13.889-22.46L39.12 11.12 25.972 24.267a2.777 2.777 0 00-.759 1.418l-.817 4.087 4.085-.818a2.765 2.765 0 001.419-.76l13.156-13.153zm0 0l-3.928-3.929 1.963-1.963a2.779 2.779 0 113.93 3.928l-1.965 1.965zm-14.732 6.875l3.928 3.928",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsKiosk;